import * as client from "../ClientConsumer";

const routes = {
    GET_GLOBAL_CONFIGS_DATA: "/global-configs",
};

type GlobalConfigsResponseType = {
    name: string;
    value: string;
};

export function getGlobalConfigsValues(): Promise<GlobalConfigsResponseType[]> {
    return client
        .getData(routes.GET_GLOBAL_CONFIGS_DATA)
        .then((res) => res.data.configs as GlobalConfigsResponseType[]);
}
